import React, { FunctionComponent } from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/material/styles";
import { colorGrayDark } from "../../styles/theme";

const bounce = keyframes`
	0%, 60%, 100% {
		transform: translateY(0);
		opacity: 0.4;
	}
	30% {
		transform: translateY(-5px);
		opacity: 1;
	}
`;

const TypingIndicator: FunctionComponent = () => {
	return (
		<Box
			sx={{
				alignSelf: "flex-start",
				display: "flex",
				alignItems: "center",
				gap: "5px",
				padding: "14px",
				borderRadius: "12px 12px 12px 2px",
				backgroundColor: "white",
			}}
		>
			{[0, 1, 2].map((dot) => (
				<Box
					key={dot}
					sx={{
						width: "8px",
						height: "8px",
						borderRadius: "50%",
						backgroundColor: colorGrayDark,
						animation: `${bounce} 1.2s infinite ease-in-out`,
						animationDelay: `${dot * 0.2}s`,
					}}
				/>
			))}
		</Box>
	);
};

export default TypingIndicator;
